export const queryMixin = {
    methods: {
        getQuery( object, paramName ) {
            return Object.entries( object ).map( ( [ key, val ] ) => `${ paramName }[${key}]=${val}` ).join('&')
        }
    }
}